import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 * @extends JetView
 */
export default class recordTableWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for displaying detailed withdrawal request information
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'windowDetailsWithdrawal',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying details
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                select: true,
                columns: [
                    {
                        id: 'detailTittle',
                        header: '',
                        width: 50,
                        height: 25,
                        tooltip: 'Detalles', // Tooltip for details
                        template: function (obj) {
                            return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                        },
                    },
                    { id: 'Id', header: 'ID', width: 80, sort: 'int' }, // ID column
                    {
                        id: 'UserModifId',
                        header: _('Modificó'), // Modified by column
                        width: 90,
                        sort: 'int',
                    },
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                    { id: 'Type', header: _('Tipo'), width: 90, sort: 'int' }, // Type column
                    {
                        id: 'Amount',
                        header: _('Monto'), // Amount column
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Description column
                        width: 250,
                        sort: 'int',
                    },
                ],
                onClick: {
                    details: function (euv, id) {
                        var item = this.getItem(id); // Get clicked item
                        vthis.app.callEvent('withdrawTransDetail:select', [
                            item, // Trigger event with selected item
                        ]);
                        $$('detailsWithdrawal').show(); // Show details window
                    },
                },
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true,
            scrollY: screen.width < 820 ? false : true, // Conditional scroll based on screen width
            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
            columns: [
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Detalles', // Tooltip for details
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                    },
                },
                { id: 'Id', header: 'ID', width: 80, sort: 'int' }, // ID column
                {
                    id: 'UserModifId',
                    header: _('Modificó'), // Modified by column
                    width: 90,
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                { id: 'Type', header: _('Tipo'), width: 90, sort: 'int' }, // Type column
                {
                    id: 'Amount',
                    header: _('Monto'), // Amount column
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Description column
                    width: 250,
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get clicked item
                    this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with selected item
                },
            },
            tooltip: true, // Enable tooltips
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        var url =
            devConfig.geturlApi() + // API URL for fetching withdrawal requests
            'es/Client/GetClientWithdrawalRequestsDetail';
        this.on(this.app, 'user:id', (idUser) => {
            grid.load(url + '?id=' + idUser); // Load grid data based on user ID
            $$('dtDetails').clearAll(); // Clear details table
            $$('dtDetails').load(url + '?id=' + idUser); // Load details based on user ID
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
